import axios from './axios'

const instance = axios.create({
    baseURL: `http://localhost:8080/api`,
    headers: {
        'Access-Control-Allow-Origin': '*',
        "Content-Type": "application/json"
    },
});

export const setBaseMCPUrl = (url) => {
    instance.defaults.baseURL = url;
};

export default instance;
